import type { Mission } from '../missions.ts'

export const cbp: Mission = {
  id: "cbp",
  name: "U.S. Customs and Border Protection",
  short: "CBP",
  call: "Protection",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.cbp.gov/",
  established: 2003,
  palette: {
    primary: "#204970",
    secondary: "#972235",
    accent: "#baa276",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_U.S._Customs_and_Border_Protection.png",
  },
  motif: "globe",
  mission: {
    text: "Protect the American people, safeguard our borders and enhance the nation’s economic prosperity.",
    url: "https://www.cbp.gov/about",
  },
  fact: {
    text: "CBP's Customs role traces to July 31, 1789, when the Fifth Act of the First Congress created the U.S. Customs Service.",
    url: "https://www.cbp.gov/about/history",
  },
  seal: {
    file: "public/seals/cbp.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_U.S._Customs_and_Border_Protection.png",
  },
  identifier: {
    about: "https://www.cbp.gov/about",
    accessibility: "https://www.cbp.gov/site-policy-notices/accessibility",
    foia: "https://www.cbp.gov/site-policy-notices/foia",
    noFear: "https://www.cbp.gov/about/eeo/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.cbp.gov/document/publications/cbp-strategy-2021-2026",
    privacy: "https://www.cbp.gov/site-policy-notices/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/cbp-p3-aircraft.jpg",
        small: "/media/cbp-p3-aircraft-sm.jpg",
        alt: "A white CBP P-3 Orion with a large radar dome on its back flying against a clear blue sky.",
        title: "CBP P-3 Airborne Early Warning aircraft in flight, January 22, 2009",
        creator: "U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:P-3_AEW_US_Customs_and_Border_Protection_in_flight_2009.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/cbp-bridge-of-the-americas.jpg",
        small: "/media/cbp-bridge-of-the-americas-sm.jpg",
        alt: "Aerial view of the Bridge of the Americas land port of entry in El Paso, with lanes of vehicles approaching the inspection booths and mountains beyond.",
        title: "Bridge of the Americas Land Port of Entry, El Paso, Texas, July 18, 2024",
        creator: "CBP Photography, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:Bridge_of_the_Americas_Port_of_Entry_in_El_Paso_(53897488546).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
